<template>
    <button
        :is="href === '' ? 'button' : 'a'"
        :class="[
            {
                'cursor-pointer rounded-full uppercase': true,
                'py-2 px-4 text-sm border': isSmall,
                'py-4 px-8 text-lg border-2': isLarge,
                'py-3 px-6 border-2': !isSmall && !isLarge,
                'inline-block': href !== ''
            },
            buttonClasses
        ]"
        :href="href ? href : false"
        :disabled="isDisabled"
        @click="$emit('click', $event)"
    >
        <span class="font-serif-medium">
            <m-icon v-if="icon" size="13" stroke="2" :name="icon"></m-icon>
            <slot></slot>
        </span>
        <span v-if="isLoading" class="inline-block w-4 h-4 ml-2">
            <m-loading :is-loading="isLoading" />
        </span>
    </button>
</template>

<script>
import MLoading from "../../elements/loading.vue";
import MIcon from "../../components/icons/icon.vue";

export default {
    name: "BaseButton",
    components: {
        MLoading,
        MIcon
    },
    props: {
        href: { type: String, default: "" },
        buttonClasses: { type: String, default: "" },
        isLoading: { type: Boolean, default: false },
        isDisabled: { type: Boolean, default: false },
        isSmall: { type: Boolean, default: false },
        isLarge: { type: Boolean, default: false },
        icon: { type: String, default: "" }
    }
};
</script>

<style scoped lang="scss">
button.button,
a.button {
    -webkit-appearance: none;
}
</style>
